import type { ReactNode } from 'react';

import { cx } from '../../../utils/cx';

/**
 * @fileoverview ModalContent component for TRM UI Kit
 *
 * Main content area with consistent padding.
 */

/**
 * ModalContent - Main content area with consistent padding
 *
 * @example
 * ```tsx
 * <ModalContent>
 *   <p>Your modal content here</p>
 * </ModalContent>
 * ```
 */
export const ModalContent = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => <div className={cx('px-6', className)}>{children}</div>;
